import { render, staticRenderFns } from "./OrganizeLocationDetails.vue?vue&type=template&id=82548b0c&scoped=true&"
import script from "./OrganizeLocationDetails.vue?vue&type=script&lang=js&"
export * from "./OrganizeLocationDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrganizeLocationDetails.vue?vue&type=style&index=0&id=82548b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82548b0c",
  null
  
)

export default component.exports